var _rect, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgOpenRedFolder(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_480_18714",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 24,
    height: 25
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 0.5,
    width: 24,
    height: 24,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_480_18714)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.29999 21.3499C3.41666 21.3499 2.67083 21.0457 2.06249 20.4374C1.45416 19.8291 1.14999 19.0832 1.14999 18.1999V6.7999C1.14999 5.8999 1.45416 5.1499 2.06249 4.5499C2.67083 3.9499 3.41666 3.6499 4.29999 3.6499H9.62499L12 6.0249H19.7C20.6 6.0249 21.35 6.32907 21.95 6.9374C22.55 7.54574 22.85 8.29157 22.85 9.1749H10.7L8.32499 6.7999H4.29999V18.3249L6.59999 11.1749H24.175L21.85 18.3999C21.5167 19.4166 21.025 20.1624 20.375 20.6374C19.725 21.1124 18.875 21.3499 17.825 21.3499H4.29999ZM7.67499 18.1999H18.6L19.825 14.3249H8.89999L7.67499 18.1999Z",
    fill: "#C30F0E"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOpenRedFolder);
export default __webpack_public_path__ + "static/media/open-red-folder.c65beef912615bc465f49d09ffd96824.svg";
export { ForwardRef as ReactComponent };